import React, { FC, memo } from 'react';
import { TImage } from './Image.types';
import SImage from './Image.styles';

const Image: FC<TImage> = props => {
  return <SImage {...props} />;
};

export default memo(Image);
